import React from 'react';
import { Helmet } from 'react-helmet';
import { isWeb } from 'src/utils/platform';
import { getListPageMetaLinks } from 'src/utils/seo/getListPageMetaLinks';
/**
 * Auto-injects `rel="prev"`/`rel="next"` head links for a navigation-mode list.
 * Derived entirely from the list's pagination state + current URL, so screens
 * never wire prev/next hrefs by hand.
 */
const PaginationSeoLinks = ({ offset, limit, hasMore, buildPageUrl, }) => {
    if (!isWeb) {
        return null;
    }
    const { prevPageHref, nextPageHref } = getListPageMetaLinks(buildPageUrl, offset, limit, hasMore);
    if (!prevPageHref && !nextPageHref) {
        return null;
    }
    return (React.createElement(Helmet, null,
        prevPageHref && React.createElement("link", { rel: "prev", href: prevPageHref }),
        nextPageHref && React.createElement("link", { rel: "next", href: nextPageHref })));
};
export default PaginationSeoLinks;
